import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "../locationServe/locationserve.css";
import { GET_CITY_SEO_DATA } from "store/Action/HomeAction";

const StateAndCities = ({ handelSelectState }) => {
  const dispatch = useDispatch();
  //ALL SELECTORS
  const { STATES } = useSelector((store) => ({
    STATES: store.HomeReducer.states.data,
  }));

  const handelSetSeoCityData = (data) => {
    const result = {
      title: data?.title_tag ?? "",
      description: data?.meta_description ?? "",
      keyword: data?.keywords ?? "",
    };
    setTimeout(() => {
      dispatch(GET_CITY_SEO_DATA(result));
    }, 500);
  };

  return (
    <div>
      <div className="location-menus">
        <Row>
          {STATES &&
            STATES?.length !== 0 &&
            STATES?.map((item) => {
              return (
                <Col
                  md={3}
                  sm={4}
                  xs={6}
                  className="mb-lg-5 mb-3"
                  key={item?.id}
                >
                  <div>
                    <h3>{item?.name}</h3>
                    <ul>
                      {item?.cities.map((data) => {
                        return (
                          <li key={data?.city_id}>
                            <span
                              onClick={() => {
                                handelSetSeoCityData(data);
                                handelSelectState(data);
                              }}
                            >
                              {data?.city_name}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </Col>
              );
            })}
        </Row>
      </div>
    </div>
  );
};

export default StateAndCities;
